import { useParams } from "react-router-dom";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import AddDoctorAnalysis from "../../../components/screen/patientCare/patientCareDoctorAnalysis/AddDoctorAnalysis";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const DetailMedicalRecordPage = () => {
  const { id } = useParams();
  return (
    <PageTemplate
      header={`Detail Patient Medical Record`}
      mainComponent={
        <ThemeProvider theme={theme}>
          <AddDoctorAnalysis isDetail={true} />
        </ThemeProvider>
      }
      pageRole={17}
    />
  );
};

export default HOC(DetailMedicalRecordPage);
